module.exports = __webpack_public_path__ + "static/img/sebastian_logo_blackfilled_blueeyes.940e7d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_logo_blackfilled_blueeyes.png
// module id = GFwi
// module chunks = 0